import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import RoleBasedGuard from 'src/auth/guard/role-based-guard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const PatientListView = lazy(() => import('src/pages/medicore/patient/list'));
const EditPatientPage = lazy(() => import('src/pages/medicore/patient/edit'));
const Prueba = lazy(() => import('src/pages/medicore/rawing/prueba'));

// ----------------------------------------------------------------------

export const patientRoutes = [
  {
    path: 'patient',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['doctor', 'employee']}>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <PatientListView />, index: true },
      // La pantalla de nueva admisión vive ahora en /medicore/admissions/new,
      // detrás del guard de permisos por ruta del módulo. Se conserva la
      // redirección para no romper enlaces, nav guardado ni marcadores.
      { path: 'new', element: <Navigate to={paths.medicore.admissionNew} replace /> },
      { path: 'edit/:id', element: <EditPatientPage /> },
      { path: 'list', element: <PatientListView /> },
      { path: 'rawing', element: <Prueba /> },
    ],
  },
];
